import { createSelector } from '@ngrx/store';
import { AppState } from '../app.reducer';

export const selectUserFileState = (state: AppState) =>
  state.userFile;


export const selectLoading = createSelector(
  selectUserFileState,
  (state) => state.loading
);
export const selectUserFiles = createSelector(
  selectUserFileState,
  (state) => state.userFiles
);
export const selectPaging = createSelector(
  selectUserFileState,
  (state) => state.paging
);
export const selectSiteImages = createSelector(
  selectUserFileState,
  (state) => state.siteImages
);
export const selectDeletingFinalUsersList = createSelector(
  selectUserFileState,
  (state) => state.deletingList
);
export const selectDeletedFinalUsersList = createSelector(
  selectUserFileState,
  (state) => state.deletedList
);
export const selectExportingFinalUsersList = createSelector(
  selectUserFileState,
  (state) => state.exportingFu
);
export const selectExportedFinalUsersList = createSelector(
  selectUserFileState,
  (state) => state.exportedFu
);
export const selectFinalUsersLists = createSelector(
  selectUserFileState,
  (state) => state.finalUsersLists
);
export const selectFinalUsersPaging = createSelector(
  selectUserFileState,
  (state) => state.finalUsersPaging
);
export const selectFinalUsersListLoading = createSelector(
  selectUserFileState,
  (state) => state.fuListLoading
);
export const selectFinalUsersListEditing = createSelector(
  selectUserFileState,
  (state) => state.editing
);
export const selectFinalUsersListEdited = createSelector(
  selectUserFileState,
  (state) => state.edited
);
export const selectFinalUsersListExported = createSelector(
  selectUserFileState,
  (state) => state.exportedFu
);
export const selectImportingFinalUsers = createSelector(
  selectUserFileState,
  (state) => state.importing
);
export const selectImportedFinalUsers = createSelector(
  selectUserFileState,
  (state) => state.imported
);
export const selectDeletingFinalUsers = createSelector(
  selectUserFileState,
  (state) => state.deletingFu
);
export const selectDeletedFinalUsers = createSelector(
  selectUserFileState,
  (state) => state.deletedFu
);

//----------------------------EXPORT DEVICE
export const selectExportDeviceList = createSelector(
  selectUserFileState,
  (state) => state.exportDeviceList
);
export const selectExportDevicePaging = createSelector(
  selectUserFileState,
  (state) => state.exportDevicePaging
);
export const selectExportDeviceListLoading = createSelector(
  selectUserFileState,
  (state) => state.exportDeviceListLoading
);
export const selectExportingDevice = createSelector(
  selectUserFileState,
  (state) => state.exportingDevice
);
export const selectExportedDevice = createSelector(
  selectUserFileState,
  (state) => state.exportedDevice
);
export const selectUpdatedExportDevice = createSelector(
  selectUserFileState,
  (state) => state.updatedExportDevice
);
export const selectUpdatingExportDevice = createSelector(
  selectUserFileState,
  (state) => state.updatingExportDevice
);
export const selectDeletedExportDevice = createSelector(
  selectUserFileState,
  (state) => state.deletedExportDevice
);
export const selectDeletingExportDevice = createSelector(
  selectUserFileState,
  (state) => state.deletingExportDevice
);
export const selectImportingDevice = createSelector(
  selectUserFileState,
  (state) => state.importingDevice
);
export const selectImportedDevice = createSelector(
  selectUserFileState,
  (state) => state.importedDevice
);
//----------------------------EXPORT DEVICE

//----------------------------EXPORT DEVICE MTMA
export const selectExportMtmaDeviceList = createSelector(
  selectUserFileState,
  (state) => state.exportMtmaDeviceList
);
export const selectExportMtmaDevicePaging = createSelector(
  selectUserFileState,
  (state) => state.exportMtmaDevicePaging
);
export const selectExportMtmaDeviceListLoading = createSelector(
  selectUserFileState,
  (state) => state.exportMtmaDeviceListLoading
);
export const selectExportingMtmaDevice = createSelector(
  selectUserFileState,
  (state) => state.exportingMtmaDevice
);
export const selectExportedMtmaDevice = createSelector(
  selectUserFileState,
  (state) => state.exportedMtmaDevice
);
export const selectUpdatedMtmaExportDevice = createSelector(
  selectUserFileState,
  (state) => state.updatedMtmaExportDevice
);
export const selectUpdatingMtmaExportDevice = createSelector(
  selectUserFileState,
  (state) => state.updatingMtmaExportDevice
);
export const selectDeletedMtmaExportDevice = createSelector(
  selectUserFileState,
  (state) => state.deletedMtmaExportDevice
);
export const selectDeletingMtmaExportDevice = createSelector(
  selectUserFileState,
  (state) => state.deletingMtmaExportDevice
);
export const selectImportingMtmaDevice = createSelector(
  selectUserFileState,
  (state) => state.importingMtmaDevice
);
export const selectImportedMtmaDevice = createSelector(
  selectUserFileState,
  (state) => state.importedMtmaDevice
);
//----------------------------EXPORT DEVICE MTMA
